import { createRouter, createWebHistory } from 'vue-router'
import Auth from '@/utils/auth'
import { useGlobalStore } from '@/store/global'
import AppLayout from '@/layouts/AppLayout.vue'

let initialized = false

const routes = [
  {
    path: '/',
    component: AppLayout,
    children: [
      { path: '', redirect: '/custom' },
      {
        path: 'custom',
        name: 'CustomList',
        component: () => import('@/views/custom/CustomList.vue'),
        meta: { title: '学习任务' }
      },
      {
        path: 'custom/:courseCustomId',
        name: 'CustomDetail',
        component: () => import('@/views/custom/CustomDetail.vue'),
        meta: { title: '任务详情' }
      },
      {
        path: 'material',
        name: 'MaterialList',
        component: () => import('@/views/material/MaterialList.vue'),
        meta: { title: '学习资料' }
      },
      {
        path: 'course',
        name: 'CourseHome',
        component: () => import('@/views/course/CourseHome.vue'),
        meta: { title: '公开课' }
      },
      {
        path: 'course/list',
        name: 'CourseList',
        component: () => import('@/views/course/CourseList.vue'),
        meta: { title: '全部课程' }
      },
      {
        path: 'course/:courseId',
        name: 'CourseDetail',
        component: () => import('@/views/course/CourseDetail.vue'),
        meta: { title: '课程详情' }
      },
      {
        path: 'play/:resourceId',
        name: 'ResourcePlay',
        component: () => import('@/views/play/ResourcePlay.vue'),
        meta: { title: '视频学习' }
      },
      {
        path: 'exam/:testId',
        name: 'ExamIntroduce',
        component: () => import('@/views/exam/ExamIntroduce.vue'),
        meta: { title: '考试详情' }
      },
      {
        path: 'exam/:testId/answer',
        name: 'ExamDetail',
        component: () => import('@/views/exam/ExamDetail.vue'),
        meta: { title: '考试答题' }
      },
      {
        path: 'exam/:testId/result',
        name: 'ExamResult',
        component: () => import('@/views/exam/ExamResult.vue'),
        meta: { title: '考试结果' }
      },
      {
        path: 'profile',
        name: 'ProfileIndex',
        component: () => import('@/views/profile/ProfileIndex.vue'),
        meta: { title: '个人中心' }
      },
      {
        path: 'profile/point',
        name: 'MyPoint',
        component: () => import('@/views/profile/MyPoint.vue'),
        meta: { title: '积分明细' }
      },
      {
        path: 'profile/level',
        name: 'MyLevel',
        component: () => import('@/views/profile/MyLevel.vue'),
        meta: { title: '我的等级' }
      },
      {
        path: 'profile/setting',
        name: 'Setting',
        component: () => import('@/views/profile/Setting.vue'),
        meta: { title: '设置' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory('/member/'),
  routes
})

router.beforeEach(async (to, from, next) => {
  const ok = await Auth.ensureAuth()
  if (!ok) {
    next(false)
    return
  }
  if (!initialized) {
    try {
      const account = await Auth.refreshAccount()
      if (account) useGlobalStore.setAccountInfo(account)
      await Promise.all([
        useGlobalStore.loadEnumData(),
        useGlobalStore.loadCompanyStyle()
      ])
      initialized = true
    } catch (e) {
      next(false)
      return
    }
  }
  if (to.meta.title) document.title = to.meta.title + ' - 学习中心'
  next()
})

export default router
